import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const BooksPage = () => {
  const books = [
    {
      title: 'Family Secrets: A San Francisco Saga',
      year: '2024',
      description:
        'A captivating multi-generational saga that follows a San Francisco family through decades of hidden truths, unexpected revelations, and the enduring bonds that hold them together despite the secrets that threaten to tear them apart.',
      image: 'https://static.readdy.ai/image/09a869d581523d35fa4e4396fbda86f5/85c5105b512ab525c6805a40d3f56727.jpeg',
      amazonLink: 'https://www.amazon.com/Family-Secrets-San-Francisco-Saga/dp/196736172X',
      featured: true,
    },
    {
      title: 'The Serpent Beguiled Me And I Ate',
      year: '2023',
      description:
        'A thought-provoking exploration of temptation, choice, and consequence. This compelling narrative delves into the complexities of human nature and the age-old struggle between desire and morality.',
      image: 'https://public.readdy.ai/ai/img_res/2c59a55374c6e7198b2ea59c25a51fbe.jpg',
      amazonLink: 'https://www.amazon.com/stores/Edward-J.-Dumke/author/B001KDIDRS',
      featured: false,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-[#F8F6F3]">
        <div className="max-w-6xl mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-serif text-6xl text-[#2C2C2C] mb-6">
              Published Works
            </h1>
            <div className="flex items-center justify-center mb-6">
              <div className="h-0.5 w-32 bg-[#C9A961]"></div>
            </div>
            <p className="text-xl text-[#666666] leading-relaxed max-w-3xl mx-auto">
              Explore the collection of novels that bring San Francisco's rich history 
              and compelling family stories to life
            </p>
          </motion.div>
        </div>
      </section>

      {/* Books Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 gap-16">
            {books.map((book, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className={`bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 ${
                  book.featured ? 'lg:col-span-2' : ''
                }`}
              >
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 p-8 lg:p-12">
                  <div className="flex justify-center items-center">
                    <div className="relative">
                      {book.featured && (
                        <div className="absolute -top-4 -right-4 bg-[#C9A961] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-lg z-10 whitespace-nowrap">
                          Featured
                        </div>
                      )}
                      <img
                        src={book.image}
                        alt={book.title}
                        className="w-full max-w-sm rounded-lg shadow-2xl hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                  </div>

                  <div className="flex flex-col justify-center">
                    <span className="text-sm tracking-widest text-[#C9A961] uppercase mb-4">
                      Published {book.year}
                    </span>
                    <h2 className="font-serif text-4xl text-[#2C2C2C] mb-6">
                      {book.title}
                    </h2>
                    <p className="text-lg text-[#666666] leading-relaxed mb-8">
                      {book.description}
                    </p>

                    <div className="flex flex-wrap gap-4">
                      <a
                        href={book.amazonLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-8 py-3 bg-[#8B2635] text-white rounded-full hover:bg-[#6d1e29] transition-all shadow-md whitespace-nowrap"
                      >
                        View on Amazon
                      </a>
                      <button className="px-8 py-3 bg-white border-2 border-[#8B2635] text-[#8B2635] rounded-full hover:bg-[#8B2635] hover:text-white transition-all whitespace-nowrap">
                        Read Sample
                      </button>
                    </div>

                    <div className="mt-8 pt-8 border-t border-gray-200">
                      <div className="flex items-center space-x-6 text-sm text-[#666666]">
                        <div className="flex items-center space-x-2">
                          <i className="ri-book-open-line text-[#C9A961] text-xl"></i>
                          <span>Paperback & Kindle</span>
                        </div>
                        <div className="flex items-center space-x-2">
                          <i className="ri-star-fill text-[#C9A961] text-xl"></i>
                          <span>Bestseller</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-20 bg-[#F8F6F3]">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="font-serif text-4xl text-[#2C2C2C] mb-6">
              Stay Updated on New Releases
            </h2>
            <p className="text-lg text-[#666666] leading-relaxed mb-8">
              Be the first to know about upcoming books, special editions, and exclusive content
            </p>
            <a
              href="/contact"
              className="inline-block px-8 py-3 bg-[#8B2635] text-white rounded-full hover:bg-[#6d1e29] transition-all shadow-md whitespace-nowrap"
            >
              Get in Touch
            </a>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BooksPage;